import { Swiper } from 'swiper';
import { Scrollbar, A11y } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/scrollbar';

function initSpringGroveBrandSlider(root) {
  const swiperElement = root.querySelector('[data-sg-card-grid-swiper]');
  if (!swiperElement || swiperElement.classList.contains('swiper-initialized')) {
    return;
  }

  const slides = swiperElement.querySelectorAll('.swiper-slide');
  if (slides.length < 2) {
    return;
  }

  const scrollbarElement = root.querySelector('[data-sg-card-grid-scrollbar]');

  new Swiper(swiperElement, {
    modules: [Scrollbar, A11y],
    grabCursor: true,
    watchOverflow: true,
    speed: 650,
    slidesPerView: 1.15,
    spaceBetween: 8,
    breakpoints: {
      640: {
        slidesPerView: 1.5,
        spaceBetween: 8,
      },
      900: {
        slidesPerView: 2.2,
        spaceBetween: 8,
      },
      1280: {
        slidesPerView: 3.15,
        spaceBetween: 8,
      },
    },
    scrollbar: scrollbarElement
      ? {
          el: scrollbarElement,
          draggable: true,
          hide: false,
        }
      : undefined,
    a11y: {
      enabled: true,
      prevSlideMessage: 'Previous brand card',
      nextSlideMessage: 'Next brand card',
    },
  });
}

function initSpringGroveBrandSliders() {
  document.querySelectorAll('.spring-grove-card-grid--brand [data-sg-card-grid-slider]').forEach((root) => {
    initSpringGroveBrandSlider(root);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSpringGroveBrandSliders);
} else {
  initSpringGroveBrandSliders();
}